export const getFormatText = (text: string) => {
  return text;
};
